import React, { useState } from 'react';
import { Image, theme } from 'antd';
import { PictureOutlined } from '@ant-design/icons';

interface ProductThumbProps {
  /** Адрес фото листинга; `null`/`undefined` — фото нет или оно ещё не пришло. */
  src: string | null | undefined;
  size: number;
  alt: string;
}

/**
 * Квадратная миниатюра фото товара, по клику — фото крупно. Без фото — рамка с
 * иконкой того же размера, чтобы строки списка не прыгали, когда фото догружается.
 */
const ProductThumb: React.FC<ProductThumbProps> = ({ src, size, alt }) => {
  const { token } = theme.useToken();
  // Amazon мог убрать файл фото, пока адрес жил в кэше: битую картинку не рисуем.
  const [brokenSrc, setBrokenSrc] = useState<string | null>(null);
  const frame: React.CSSProperties = {
    width: size,
    height: size,
    flexShrink: 0,
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${token.colorBorderSecondary}`,
    background: token.colorBgContainer,
    overflow: 'hidden',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  if (!src || src === brokenSrc) {
    return (
      <span style={{ ...frame, color: token.colorTextQuaternary, fontSize: size / 2.5 }} aria-label={alt} role="img">
        <PictureOutlined />
      </span>
    );
  }

  return (
    <span style={frame} onClick={(event) => event.stopPropagation()}>
      <Image
        src={src}
        alt={alt}
        width={size}
        height={size}
        style={{ objectFit: 'contain' }}
        preview={{ mask: false }}
        onError={() => setBrokenSrc(src)}
      />
    </span>
  );
};

export default ProductThumb;
